// 当报表的数据为每日数据为0时，展示--。
export var countEmpty = '- -'

// 登录类型，目前用处不大。
export const wx = 1
export const msg = 0
export const pw = 2
